import { createAction } from '@reduxjs/toolkit';
import { getPayloadCreator } from '../core/actionHelpers';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type { Customer, CustomerProps } from './customersTypes';

const errorPayloadCreator = getPayloadCreator<{ id?: string; message?: string }>();
const syncCustomersPayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<CustomerProps>>();
const customerPayloadCreator = getPayloadCreator<Customer>();

export const getCustomers = createAction('GET_CUSTOMERSS', getPayloadCreator());
export const getCustomersSuccess = createAction('GET_CUSTOMERSS_SUCCESS', syncCustomersPayloadCreator);
export const getCustomersFailure = createAction('GET_CUSTOMERSS_FAILURE', errorPayloadCreator);

export const createCustomer = createAction('CREATE_CUSTOMER', customerPayloadCreator);
export const createCustomerSuccess = createAction('CREATE_CUSTOMER_SUCCESS', customerPayloadCreator);
export const createCustomerFailure = createAction('CREATE_CUSTOMER_FAILURE', errorPayloadCreator);

export const updateCustomer = createAction('UPDATE_CUSTOMER', customerPayloadCreator);
export const updateCustomerSuccess = createAction('UPDATE_CUSTOMER_SUCCESS', customerPayloadCreator);
export const updateCustomerFailure = createAction('UPDATE_CUSTOMER_FAILURE', errorPayloadCreator);

export const deleteCustomer = createAction('DELETE_CUSTOMER', customerPayloadCreator);
export const deleteCustomerSuccess = createAction('DELETE_CUSTOMER_SUCCESS', customerPayloadCreator);
export const deleteCustomerFailure = createAction('DELETE_CUSTOMER_FAILURE', errorPayloadCreator);
